import React from 'react';
import TitleLight from '../../components/Text/TitleLight';
import MainStyles from '../../styles/MainStyles';
import './index.css'

const ModelDetails = ({selectedModel}) => {
  return (
    <div className='model-details'>
      <TitleLight
        text={selectedModel.versionName}
        size={'medium'}
        color={MainStyles.colors.white}
      />
      <br/>
      {(selectedModel.colorCode !== '####') &&
        <div>
          <TitleLight
            text={selectedModel.colorName}
            size={'medium'}
            color={MainStyles.colors.white}
          />
          <br/>
        </div>
      }
      <TitleLight
        text={selectedModel.modelYear}
        size={'medium'}
        color={MainStyles.colors.white}
      />
      <br/>
      <TitleLight
        text={selectedModel.vin}
        size={'medium'}
        color={MainStyles.colors.white}
      />
      <br/>
      <TitleLight
        text={selectedModel.plate ? selectedModel.plate : selectedModel.licensePlate}
        size={'medium'}
        color={MainStyles.colors.white}
      />
    </div>
  )
}

export default ModelDetails